import { getDataFromSSR } from "@/handlers/client/commonClient";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";

const StatesConstituencyLiveResult = ({
  electionPassedCategory,
  electionConfigData,
  stateName

}) => {
  const autoLiveBlogRedirect = electionConfigData?.autoLiveBlogRedirect;
  const [activeliveBlogs, setActiveliveBlogs] = useState([]);
  const [constituencyList, setConstituencyList] = useState([]);
  const [visibleList, setVisibleList] = useState([]);
  const [loading, setLoading] = useState(true);
  const router = useRouter();
  const currentPath = router?.asPath;
  const [activeBlogs, setActiveBlogs] = useState([]);
  const constituencyId =
    currentPath?.split("-")[currentPath?.split("-").length - 1];
const [page, setPage] = useState(1);
  const getLiveBlogsData = async (pageNumber=1) => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    try {
      const response = await getDataFromSSR(
        `${websiteUrl}/api/getLiveBlogElectionResult?page=${pageNumber}`
      );
      // console.log("response", response?.data?.data?.content);
      setActiveBlogs(response?.data?.data)
      // setActiveliveBlogs(response?.data?.data?.content);
      const fetchedData = response?.data?.data?.content;
       if (pageNumber === 1) {
      setActiveliveBlogs(fetchedData);
    } else {
      setActiveliveBlogs((prev) => [...prev, ...fetchedData]);
    }
    } catch (error) {
      console.error("Error fetching live blogs:", error);
    }
  };

  useEffect(() => {
    getLiveBlogsData();
  }, []);

  useEffect(() => {
    const fetchConstituencyData = async () => {
      if (!electionConfigData?.autoLiveBlog) return;
      if (!activeliveBlogs || activeliveBlogs.length === 0) return;

      try {
        const response = await fetch(
          "https://akm-img-a-in.tosshub.com/sites/elections/2025/assembly/json/state-master/bihar-state-master.json"
        );
        const data = await response.json();
        const constituencyListData = data;

        const blogs = activeliveBlogs 
        const activeBlogs =
          blogs?.map((item) => item?.title_short?.split(",")[0]?.trim()) || [];

        const filteredList =
          constituencyListData?.data
            ?.filter((item) =>
              activeBlogs?.some((title) =>
                title?.toLowerCase()?.includes(item?.cons_name?.toLowerCase())
              )
            )
            ?.map((item) => {
              const matchedBlog = blogs?.find((blog) =>
                blog?.title_short
                  ?.toLowerCase()
                  .includes(item?.cons_name?.toLowerCase())
              );
              return {
                ...item,
                blogUrl: matchedBlog?.canonical_url,
                cons_name_en: `${item?.cons_name} Election Result Live`,
              };
            }) || [];

        // remove duplicates by cons_id
        const uniqueList = Array.from(
          new Map(filteredList.map((item) => [item.cons_id, item])).values()
        );

        setConstituencyList(uniqueList);
        setVisibleList(uniqueList.slice(0, activeliveBlogs?.length)); // Initially show 10 items
      } catch (err) {
        console.error("Error fetching constituency data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConstituencyData();
  }, [electionConfigData?.autoLiveBlog, activeliveBlogs]);

  // ✅ Load More Logic
  const handleLoadMore = () => {
    const currentLength = visibleList.length;
    const nextItems = constituencyList.slice(currentLength, currentLength + 10);
    const updatedList = [...visibleList, ...nextItems];
const nextPage = page + 1;
      setPage(nextPage);
      getLiveBlogsData(nextPage);
    setVisibleList(updatedList);
  };
 
  if (loading) return null;

  return (
    visibleList?.length > 0 && (
      <section>
        <div className="my-8">
          <h2 className="flex text-xl font-semibold mx-2">
            <span className="w-[5px] h-[25px] bg-primary inline-block mr-1"></span>
            2026 {stateName} Constituencies Live Result
          </h2>

          <div className="my-1 mx-2 bg-[#FFF] dark:bg-[#000] rounded-[10px]">
            <div className="flex flex-col border-2 border-[#E6E7E9] rounded-[20px] overflow-hidden">
              {/* Constituency List */}
              <div className="flex flex-wrap gap-x-2 gap-y-2 p-2">
                {visibleList?.map((item, index) => (
                  <a
                    key={item?.cons_id || index}
                    title={item?.cons_name}
                    href={
                      autoLiveBlogRedirect
                        ? `${
                            process?.env?.NEXT_PUBLIC_WEBSITE_URL
                          }/elections/${electionPassedCategory}/${item?.cons_name
                            .toLowerCase()
                            .replace(/[^a-zA-Z ]/g, "")
                            .split(" ")
                            .join("-")}-assembly-constituency-result-${
                            item?.cons_id
                          }`
                        : item.blogUrl ||
                          `${
                            process?.env?.NEXT_PUBLIC_WEBSITE_URL
                          }/elections/${electionPassedCategory}/${item?.cons_name
                            .toLowerCase()
                            .replace(/[^a-zA-Z ]/g, "")
                            .split(" ")
                            .join("-")}-assembly-constituency-result-${
                            item?.cons_id
                          }`
                    }
                    target={"_self"}
                  >
                    <div
                      className={`dark:bg-[#1F1F1F] dark:border-[#1F1F1F] border-2 border-[#D2D1D1]-500 rounded-[20px] px-4 py-2 ${
                        item?.cons_id == constituencyId
                          ? "bg-primary text-[#FFF]"
                          : "bg-[#EEF3F7] hover:bg-[#F5B301]"
                      }`}
                    >
                      <p className="whitespace-nowrap">
                        {item?.cons_name_en || item?.cons_name_hi}
                      </p>
                    </div>
                  </a>
                ))}
              </div>

              {/* Divider */}
              <div className="w-full border-t border-[#E6E7E9]"></div>

               
              {visibleList.length <= constituencyList.length && (
                <div className="flex justify-center py-4 bg-[#FFF] dark:bg-[#000]">
                  <button
                    onClick={handleLoadMore}
                    className="bg-primary hover:bg-primary text-white px-6 py-1.5 rounded-full text-sm font-medium shadow-md transition-all"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default StatesConstituencyLiveResult;
